import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ReplyQuestion } from '../../../components/Diagnosis/ReplyQuestion'
import useApi from '../../../hooks/useApi'
import { Button } from '../../../Korbantech/components/Buttons/Button'
import { OscLoggedLayout } from '../../../layout/OscLoggedLayout'
import { Diagnosis } from '../../../types/Diagnosis'

export const ReplyDiagnosis = () => {

    const { id } = useParams<any>()
    const api = useApi();
    const navigate = useNavigate()
    const [diagnosis, setDiagnosis] = useState<Diagnosis>()

    const loadDiagnosis = useCallback(async () => {
        await api.get("/client/diagnoses/" + id).then(res => {
            setDiagnosis(res.data)
        }).then(console.log)
    }, [id , api])

    const sendDiagnosis = useCallback(async() => {
        await api.post(`/client/diagnoses/${diagnosis?.id}`).then(res => {
             navigate(`/osc/resultado/${diagnosis?.id}`)
        }).catch(console.log)
    },[diagnosis , api , navigate])

    useEffect(() => {
        loadDiagnosis()
    }, [loadDiagnosis])

    return (
        <OscLoggedLayout>
            <div className='ml-12 flex items-center text-gray-600 mt-5 h-16'>Geral / Respondendo / {diagnosis?.name}</div>
            <div className='grid grid-cols-12'>
                <div className='ml-12 col-span-8'>
                    <div className='text-3xl font-bold text-gray-800'>Preenchendo {diagnosis?.name}</div>
                    <div>{diagnosis?.description}</div>
                    <div>
                        {diagnosis?.questions.map(item => (
                            <div key={item.id}>
                                <ReplyQuestion question={item} />
                            </div>
                        ))}
                    <div className='flex flex-col items-end'>
                        <div>
                            <Button onClick={sendDiagnosis}  value={"Enviar"} />
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </OscLoggedLayout>
    )
}